import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import EmailEditor from '../../helpers/email-editor/EmailEditor';
import useEmailEditorStore from '../../helpers/email-editor/utilities/emailEditorStore';
import { htmlExport } from '../../helpers/email-editor/utilities/htmlExport';
import templateService from '../../../services/template.service';
import Loading from '../../common/Loading';
import { toast } from 'react-toastify';

function ClinicEditEmailTemplate() {
    const { clinicId, templateId } = useParams();
    const [txtType, setTxtType] = useState('PREBOOKED_REMINDER');
    const [txtUsedBy, settxtUsedBy] = useState('CLINIC');
    const [txtSubject, setTxtSubject] = useState('');
    const [loadJson, setLoadJson] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();
    const { blocks, globalProperties, exportTemplate } = useEmailEditorStore();

    const handleTextChange = (event) => {
        setTxtSubject(event.target.value);
    };

    const exportHtml = () => {
        try {
            const html = htmlExport(blocks, globalProperties);
            const template = exportTemplate();
            const jsonString = JSON.stringify(template);

            const edata = {
                id: templateId,
                clinicId,
                type: txtType,
                mediumType: 'EMAIL',
                subjectLine: txtSubject,
                content: html,
                jsonContent: jsonString,
                usedBy: txtUsedBy,
                status: 1,
            };

            templateService
                .updateEmailTemplate(clinicId, templateId, edata)
                .then(() => {
                    toast.success('Template Saved', {
                        position: toast.POSITION.BOTTOM_RIGHT,
                    });
                })
                .catch((err) => {
                    toast.error('Cannot Save Template.', {
                        position: toast.POSITION.BOTTOM_RIGHT,
                    });
                    console.error(err);
                });
        } catch (error) {
            toast.error('Error exporting template.', {
                position: toast.POSITION.BOTTOM_RIGHT,
            });
            console.error(error);
        }
    };

    useEffect(() => {
        if (!clinicId || !templateId) {
            setIsLoading(false);
            return;
        }

        setIsLoading(true);
        templateService
            .getEmailTemplateById(clinicId, templateId)
            .then((res) => {
                setTxtType(res.data.type);
                settxtUsedBy(res.data.usedBy);
                setTxtSubject(res.data.subjectLine || '');

                try {
                    const parsed =
                        typeof res.data.jsonContent === 'string'
                            ? JSON.parse(res.data.jsonContent)
                            : res.data.jsonContent;
                    setLoadJson(parsed);
                } catch (error) {
                    console.error('Error parsing template JSON:', error);
                    toast.error('Error loading template.', {
                        position: toast.POSITION.BOTTOM_RIGHT,
                    });
                }
            })
            .catch((err) => {
                console.error('Error while getting clinic template', err);
                toast.error('Error loading template.', {
                    position: toast.POSITION.BOTTOM_RIGHT,
                });
            })
            .finally(() => setIsLoading(false));
    }, [clinicId, templateId]);

    return (
        <div className="container container-xxl">
            <nav className="navbar mb-3 navbar-expand-lg rounded p-3" style={{ backgroundColor: '#8b02ee' }}>
                <div className="container-fluid">
                    <div className="d-flex flex-column me-4">
                        <span className="navbar-brand" style={{ color: 'white' }}>
                            Email Template
                        </span>
                        <span style={{ color: 'white' }}>{txtType}</span>
                    </div>

                    <div className="d-flex justify-content-between align-items-center flex-grow-1">
                        <label htmlFor="" className="form-label me-2" style={{ color: 'white' }}>
                            Subject
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            value={txtSubject}
                            onChange={handleTextChange}
                        />
                    </div>
                    <div className="d-flex flex-row align-items-center">
                        <button type="button" className="btn btn-sm btn-warning ms-2" onClick={exportHtml}>
                            Save
                        </button>
                        <button
                            type="button"
                            className="btn btn-sm btn-success ms-2"
                            onClick={() => navigate('/email-template')}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </nav>

            <div className="row">
                <div className="col-12">
                    {isLoading ? (
                        <Loading />
                    ) : (
                        <EmailEditor loadjson={loadJson} emailSubject={txtSubject} />
                    )}
                </div>
            </div>
        </div>
    );
}

export default ClinicEditEmailTemplate;
